export default function Testimonial() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="relative max-w-5xl mx-auto">
          <div className="relative bg-foreground-950 rounded-3xl overflow-hidden">
            <div className="flex flex-col md:flex-row">
              <div className="w-full md:w-2/5 relative">
                <div className="absolute -left-6 md:-left-12 top-1/2 -translate-y-1/2 w-[calc(100%+48px)] md:w-[calc(100%+96px)]">
                  <div className="aspect-[3/4] rounded-2xl overflow-hidden bg-foreground-800">
                    <img
                      src="https://readdy.ai/api/search-image?query=A%20stylish%20young%20model%20wearing%20trendy%20streetwear%20against%20a%20neutral%20minimal%20backdrop%2C%20warm%20lighting%2C%20editorial%20fashion%20portrait%20photography%2C%20clean%20composition%2C%20soft%20cream%20and%20beige%20tones%2C%20confident%20and%20natural%20pose&width=600&height=800&seq=testimonial-portrait-2026&orientation=portrait"
                      alt="CSSBuy spreadsheet satisfied customer"
                      className="w-full h-full object-cover object-top"
                      title="CSSBuy Spreadsheet Customer Review"
                    />
                  </div>
                </div>
              </div>

              <div className="w-full md:w-3/5 p-8 md:p-12 lg:p-16">
                <div className="text-accent-500/50 font-heading text-7xl md:text-8xl leading-none mb-2">&ldquo;</div>
                <blockquote className="text-background-50 text-base md:text-lg leading-relaxed mb-8">
                  Finding a reliable CSSBuy spreadsheet used to take me hours of digging through Discord servers and Reddit threads. This hub completely changed the game. Every category is organized perfectly, and I have discovered so many amazing sellers I would have never found on my own.
                </blockquote>
                <div className="mb-8">
                  <p className="text-background-50 font-label font-semibold text-sm">Marcus J.</p>
                  <p className="text-foreground-300 text-xs mt-0.5">Streetwear Enthusiast &amp; CSSBuy Power User</p>
                </div>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center px-6 py-3 bg-accent-500 text-background-50 font-label font-semibold text-sm rounded-full hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
                >
                  Start Exploring
                  <i className="ri-arrow-right-up-line ml-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}